// extracted by mini-css-extract-plugin
export default {"container":"Vj-z","disabled":"Wj-z","subtotal":"Xj-z","legal":"Yj-z"};